const DEFAULT_IMAGE_SVG = '/static/assets/avatar_user.svg';
export class ImageUtils {

  static getImageAvatar(path: string | null | undefined): string | null | undefined {
    return path != null && path === DEFAULT_IMAGE_SVG ? null : path;
  }

}